import "./style.css";
import { NetworkRaceClient } from "../network/NetworkRaceClient";
import { getTrackDefinition } from "../game/simulation/track";

const client = new NetworkRaceClient("overlay");
const join = document.querySelector<HTMLButtonElement>("#join")!;
const back = document.querySelector<HTMLAnchorElement>("#back")!;
const connection = document.querySelector<HTMLElement>("#connection")!;
const course = document.querySelector<HTMLElement>("#course")!;
const phase = document.querySelector<HTMLElement>("#phase")!;
const nextCourse = document.querySelector<HTMLElement>("#next-course")!;
const roster = document.querySelector<HTMLOListElement>("#roster")!;
const hint = document.querySelector<HTMLElement>("#join-hint")!;
let rosterKey = "";
let focused = false;
let leaving = false;
function update() {
  const state = client.state;
  const ready = client.connected && client.status === "CONNECTED";
  connection.textContent = ready ? "LIVE · CONNECTED" : client.status;
  join.disabled = !ready || leaving;
  if (!ready) { phase.textContent = "Reconnecting to the live lobby. Joining is unavailable until connected."; return; }
  if (!focused) { focused = true; join.focus(); }
  course.textContent = getTrackDefinition(state.trackId).name;
  phase.textContent = state.phase === "menu" ? "GRID OPEN · Waiting for racers"
    : state.phase === "countdown" ? `STARTING IN ${Math.max(0, Math.ceil(state.countdown))}…`
    : state.phase === "race" ? "RACE IN PROGRESS · Join the next grid"
    : "RACE RESULTS · Next grid after this race";
  const order = state.cup?.trackOrder ?? [];
  const currentIndex = order.indexOf(state.trackId);
  const next = currentIndex >= 0 ? order[currentIndex + 1] : undefined;
  nextCourse.textContent = next ? `UP NEXT · ${getTrackDefinition(next).name}` : "Live server controls the course rotation";
  const late = state.phase !== "menu" && state.phase !== "countdown";
  join.textContent = late ? "JOIN NEXT GRID" : "JOIN LIVE RACE";
  hint.textContent = late ? "Join with your saved kart. You will spectate until a slot opens on the next grid."
    : "Join with your saved kart and drive with controller or keyboard. Full grids queue for the next race.";
  const karts = [...state.karts].sort((a, b) => a.place - b.place);
  const key = JSON.stringify(karts.map(kart => [kart.id, kart.name, kart.controller, kart.place]));
  if (key !== rosterKey) {
    rosterKey = key;
    roster.replaceChildren(...karts.map((kart, index) => {
      const row = document.createElement("li");
      const position = document.createElement("span"); position.className = "position"; position.textContent = String(kart.place || index + 1).padStart(2, "0");
      const name = document.createElement("span"); name.className = "name"; name.textContent = kart.controller === "ai" && kart.name === "YOU" ? "HOUSE KART" : kart.name;
      const kind = document.createElement("small"); kind.textContent = kart.controller === "twitch" ? "TWITCH" : kart.controller === "human" ? "PLAYER" : "CPU";
      row.append(position, name, kind); return row;
    }));
  }
}
join.addEventListener("click", () => {
  if (join.disabled || leaving) return;
  leaving = true; join.disabled = true;
  location.assign("/?network=1&liveJoin=1");
});
// Poll connection edges as well as snapshots; no render loop or second 3D scene.
const interval = window.setInterval(update, 200);
client.connect();
window.addEventListener("pagehide", () => { clearInterval(interval); client.close(); });
window.addEventListener("pageshow", (event) => { if (event.persisted) location.reload(); });
window.addEventListener("keydown", (event) => { if (event.key === "Escape") back.click(); });
let previous: boolean[] | null = null;
function pollController() {
  const pad = Array.from(navigator.getGamepads?.() ?? []).find(pad => pad?.connected);
  if (pad) {
    const down = [pad.buttons[0]?.pressed || false, pad.buttons[1]?.pressed || false,
      pad.buttons[12]?.pressed || pad.buttons[14]?.pressed || (pad.axes[1] ?? 0) < -.55 || (pad.axes[0] ?? 0) < -.55,
      pad.buttons[13]?.pressed || pad.buttons[15]?.pressed || (pad.axes[1] ?? 0) > .55 || (pad.axes[0] ?? 0) > .55];
    if (previous) {
      if ((down[2] && !previous[2]) || (down[3] && !previous[3])) {
        (document.activeElement === join || join.disabled ? back : join).focus();
      }
      if (down[1] && !previous[1]) back.click();
      else if (down[0] && !previous[0]) {
        if (document.activeElement === back) back.click(); else if (!join.disabled) join.click();
      }
    }
    previous = down;
  } else previous = null;
  requestAnimationFrame(pollController);
}
requestAnimationFrame(pollController);
window.render_game_to_text = () => JSON.stringify({ mode: "twitch-lobby", connection: client.status, readOnly: true, phase: client.state.phase, trackId: client.state.trackId, localKartId: client.localKartId, racers: client.state.karts.map(kart => ({ id: kart.id, name: kart.name, kind: kart.controller })), joinEnabled: !join.disabled });
